// extracted by mini-css-extract-plugin
export default {"expand":"analyses_expand__hFgo1"};